import {
  NoDataComponent,
  SearchComponent,
  SkeletonGradientBackground,
  TableComponent,
  CustomButton,
  CustomSelect,
} from '@/shared/ui/components';
import { gettextRmaStatus } from '@/shared/lib';
import { facilitySelection } from '@/entities/facility';
import _ from 'lodash';
import { t } from 'ttag';
import { useRmaRequestTable } from './useRmaRequestTable';
import { OPTIONS_SEARCH_BY } from '../../config/rmaRequestTable';
import DeviceCountDrawer from './deviceCountDrawer/deviceCountDrawer';
import type { RmaRequestTableProps } from './rmaRequestTable.types';
import './rmaRequestTable.scss';

const RmaRequestTable = ({
  supportFacilities,
  selectedFacility,
  isActive,
}: RmaRequestTableProps) => {
  const {
    navigate,
    filterObject,
    statusList,
    searchInputRef,
    state,
    handleClose,
    onChangeSearchValue,
    onChangeStatus,
    handleTableChange,
    generateColumns,
  } = useRmaRequestTable({ supportFacilities, selectedFacility, isActive });

  return (
    <>
      <DeviceCountDrawer
        open={(state.clickedDevices?.length ?? 0) > 0}
        title={
          state.clickedDevicesType
            ? state.clickedDevicesType === 'outbound'
              ? t`Outbound devices`
              : t`Inbound devices`
            : ''
        }
        devices={state.clickedDevices ?? undefined}
        type={state.clickedDevicesType}
        handleClose={handleClose}
      />

      <div className="rma-request-body">
        <div className="rma-search-row">
          <CustomButton
            id="go-new-rma-btn"
            size="small"
            onClick={() => {
              navigate('/rma/new');
            }}
          >
            {t`New RMA`}
          </CustomButton>

          <div className="ml-auto flex">
            <CustomSelect
              name="status"
              className="rma-status-dropdown"
              options={_.map(statusList.current, (item) => ({
                label: gettextRmaStatus(item),
                value: item,
              }))}
              popupMatchSelectWidth={false}
              value={state.status}
              size="middle"
              onChange={onChangeStatus}
              showSearch
              allowClear={false}
              dropdownStyle={{
                minWidth: '150px',
                zIndex: 1,
              }}
              placement="bottomRight"
              aria-label={t`RMA status`}
            />

            <div className="rma-status-search">
              <SearchComponent
                ref={searchInputRef}
                searchValue={state.searchValue}
                searchByValue={state.searchByValue}
                showSearch
                options={OPTIONS_SEARCH_BY}
                onChange={onChangeSearchValue}
                inputType="number"
                popupMatchSelectWidth={false}
                dropdownStyle={{ minWidth: '145px' }}
                placement="bottomRight"
              />
            </div>
          </div>
        </div>

        <SkeletonGradientBackground isShow={!state.isLoadedData} />

        {(state.data.length || (!state.data.length && !state.isLoadedData)) &&
        (facilitySelection.userSupportFacilities()?.length > 0 || supportFacilities?.length > 0) ? (
          <TableComponent
            className="rma-request-table"
            isLoading={!state.isLoadedData}
            data={state.isLoadedData ? state.data : state.skeletonData}
            columns={generateColumns()}
            currentPage={state.page}
            pageSize={state.sizePerPage}
            isEndOfData={state.isEndOfData}
            handleTableChange={handleTableChange}
          />
        ) : (
          <div className="no-data-wrapper">
            <div className="no-data">
              <NoDataComponent
                isSearching={!!filterObject.current.rmaId || !!filterObject.current.deviceId}
              />
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default RmaRequestTable;
